import CustomLottie from '@/components/custom-lottie';
import AmericanExpressIcon from '@/icons/american-express-icon';
import ApplePayIcon from '@/icons/apple-pay-icon';
import CloseIcon from '@/icons/close-icon';
import GooglePayIcon from '@/icons/google-pay-icon';
import MasterCardIcon from '@/icons/master-card-icon';
import VisaIcon from '@/icons/visa-icon';
import { formatNumberToCurrency } from '@/lib/utils';
import { GapMagtekSdkContext } from '@/pages/(gapsdk)/_provider/gap-magtek-sdk-provider';
import {
  TCardData,
  TPaymentFailed,
  TResponseCardData,
} from '@/types/payment/charge.type';
import isEmpty from 'lodash/isEmpty';
import { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import TopNavigation from '../../../../_components/top-navigation';

const PresentCard = (props: {
  onCheckCardFailed: (error: TPaymentFailed) => void;
  onSubmitPayment: (cardData: TCardData) => void;
}) => {
  const { paymentStatus, event } = useContext(GapMagtekSdkContext);

  const [searchParams] = useSearchParams();
  const price = searchParams.get('price');

  const InitPayment = async () => {
    const response = await event.onInitPaymentCard();

    if (response && typeof response === 'object') {
      const convertData = JSON.parse(
        JSON.stringify(response),
      ) as TResponseCardData<TCardData>;

      if (convertData.data.is_timeout === 1) {
        props.onCheckCardFailed({
          error: 'TIMEOUT',
          type: 'timeout',
        });
      }

      if (convertData.data.is_cancel === 1) {
        props.onCheckCardFailed({
          error: 'Canceled',
          type: 'canceled',
        });
      }

      if (isEmpty(convertData.data.arqc)) {
        props.onCheckCardFailed({
          error: 'ARQC_INVALID',
          type: 'no_data',
        });
      }

      if (convertData.data.arqc) {
        props.onSubmitPayment(convertData.data);
      }
    }
  };

  useEffect(() => {
    InitPayment();
  }, []);

  return (
    <div className="relative flex size-full flex-col px-3 py-[60px]">
      <TopNavigation
        actions={
          <CloseIcon
            style={{ width: 24, height: 24 }}
            onClick={() => {
              event.onCancel();
              props.onCheckCardFailed({
                error: 'Canceled',
                type: 'canceled',
              });
            }}
          />
        }
      />

      <div className="flex-none text-center">
        <h2 className="mb-2 flex-none text-[32px] font-bold">Total amount</h2>
        <div className="flex-none text-[120px] font-bold">
          {formatNumberToCurrency(Number(price))}
        </div>
      </div>
      <div className="grow">
        <div className="border-C6C m-auto mb-11 mt-6 flex w-full max-w-[734px] items-center justify-center gap-x-3 rounded-lg border px-6 py-5">
          <GooglePayIcon style={{ width: 132, height: 24 }} />
          <ApplePayIcon style={{ width: 132, height: 24 }} />
          <AmericanExpressIcon style={{ width: 132, height: 24 }} />
          <MasterCardIcon style={{ width: 132, height: 24 }} />
          <VisaIcon style={{ width: 132, height: 24 }} />
        </div>
      </div>
      <div className="flex w-full flex-none flex-col items-center gap-10 text-center">
        <p className="text-[28px] uppercase">{paymentStatus}</p>
        <CustomLottie
          path="/images/lotties/insert-card-large.json"
          className="size-[76px]"
          loop={true}
        />
      </div>
    </div>
  );
};

export default PresentCard;
